import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden transition-all duration-300 hover:border-primary-300/50 hover:bg-background-50"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden">
        <img
          src={article.image}
          alt={article.imageAlt}
          title={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
            {article.category === "film"
              ? "电影"
              : article.category === "drama"
                ? "电视剧"
                : article.category === "stage"
                  ? "舞台剧"
                  : article.category === "awards"
                    ? "获奖"
                    : article.category === "biography"
                      ? "资料"
                      : "动态"}
          </span>
          <span className="text-xs text-foreground-400">{article.date}</span>
        </div>
        <h3
          className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
      </div>
    </Link>
  );
}